// import "@babel/polyfill"
import Vue from 'vue'
import global_mixin from '../global_mixins.js'
import LazyBackground from '../../components/LazyBackground.vue'
import '../../css/commercial/commercial_collection.css'
var _ = require('lodash')
import gql from 'graphql-tag'
import VueGallery from '../../components/Gallery.vue'
/*var lightGallery = require('lightgallery.js')*/
import 'lightgallery.js'
import 'lightgallery.js/dist/css/lightgallery.css'
import 'lg-video.js'
import VueTinySlider from 'vue-tiny-slider'
import CommercialContactForm from '../../components/CommercialContactForm.vue'
Vue.component('lazy-background', LazyBackground)

const app = new Vue({
  el: '#app',
  components: {
    'gallery': VueGallery,
    'commercial-contact-form': CommercialContactForm,
  },
  mixins: [global_mixin],
  data() {
    return {
      currentSlide: 0,
      seriesData: {},
      currentSeriesPolaroids: [],
      initialDataLoaded: false,
      currentSeriesID: 0,
      slideDirection: 'right',
      showGallery: false,
      isTransitioningSeries: false,
      polaroidLeft: 0,
      polaroidRight: 4,
      polaroids: [],
      currentVideo: "",
      polaroidDisplayLimit: 4,
      lightboxIndex: null,
      lightboxKey: Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15),
    }
  },
  mounted() {},
  apollo: {
    currentSeriesScenes: {
      query: gql `query allRoomScenes($before: String
        $after: String
        $first: Int
        $last: Int
        $series: [ID]
      ) {
        allRoomScenes(before: $before, after: $after, first: $first, last: $last, series: $series) {
          edges {
            node {
      				id
      				sliderLoading
      				largeImage
      				sliderImage
      				thumbnail
              position
              lightboxDescription
              tiles{
                edges{
                  node{
                    sku
                    shape{
                      size
                    }
                  }
                }
                
              }
              series{
                  videoEmbedUrl
              }
              featuredCommercial
              featuredResidential
              featuredColor {
                name
                id
                code
                family
              }
            }
          }
        }
      }`,
      update: data => data.allRoomScenes,
      variables() {
        return {
          series: [this.encodeSeriesID(this.currentSeriesID)]
        }
      },
      error(error) {
        if (error.name == 'InvariantError') {
          console.log('Invariant error found... wiping local cache!')
          this.clearApolloCache()
        }
        else {
          console.error(error)
        }
      },
      skip() {
        return this.currentSeriesID === 0
      },
      watchLoading(isLoading) {
        this.isLoading = isLoading
      },
      result(data) {
        let slides = []
        console.log(data)
        if (data.data.allRoomScenes.edges[0].node.series.videoEmbedUrl != '') {
          let href = data.data.allRoomScenes.edges[0].node.series.videoEmbedUrl
          let youtubeID = href.split("embed/")
          slides.push({
            href: data.data.allRoomScenes.edges[0].node.series.videoEmbedUrl,
            thumbnail: 'https://img.youtube.com/vi/'+youtubeID[1]+'/default.jpg',
            id: 'dsafdsfdsafdfdfrfafafadfsf'
          })
        }
        for (const scene of data.data.allRoomScenes.edges) {
          slides.push(scene.node)
        }
        this.currentSeriesPolaroids = slides
      }
    },
    initialSeries: {
      query: gql `query allSeries($inHomepageSlider: Boolean) {
        allSeries(inHomepageSlider: $inHomepageSlider) {
          edges {
            node {
              id
              name
              category
              description
              literaturePdf
              bodyComposition
              url
              videoEmbedUrl
              tagline
            }
          }
        }
      }`,
      update: data => data.allSeries,
      skip() {
        return !this.cacheLoaded
      },
      variables() {
        return {
          inHomepageSlider: true
        }
      },
      error(error) {
        if (error.name == 'InvariantError') {
          console.log('Invariant error found... wiping local cache!')
          this.clearApolloCache()
        }
        else {
          console.error(error)
        }
      },
      watchLoading(isLoading) {
        this.isLoading = isLoading
      },
    },
  },
  methods: {
    setSlideDirectionLeft() {
      this.slideDirection = 'left'
      setTimeout(() => {
        this.slideDirection = 'right'
      }, 2500)
    },
    getInfo: function(event) {
      let sliderInfo = this.$refs.tinySlider.slider.getInfo();
    }
  },
  computed: {
    previousSeries() {
      this.setSlideDirectionLeft()
      if (this.seriesIndex > 0) {
//        this.seriesIndex = this.seriesIndex - 1
        this.currentSeriesID = this.initialSeriesIDs[this.seriesIndex-1]
      }
    },
    nextSeries() {
      let slide_length_offset = this.initialSeriesIDs.length - 1
      if (this.seriesIndex < slide_length_offset) {
//        this.seriesIndex = this.seriesIndex + 1
        this.currentSeriesID = this.initialSeriesIDs[this.seriesIndex + 1]
      }
      else if (this.seriesIndex === slide_length_offset) {
//        this.seriesIndex = 0
        this.currentSeriesID = this.initialSeriesIDs[0]
      }
    },
    currentSeriesData() {
      let data = {}
      if (this.currentSeriesID !== 0 && this.initialSeries) {
        data = _.find(this.initialSeries.edges, (o) => { return o.node.id === this.encodeSeriesID(this.currentSeriesID) }).node
      }
      return data
    },
    currentSeriesSlides() {
      let slides = []
      if (this.currentSeriesScenes && this.currentSeriesScenes.edges) {
        for (const scene of this.currentSeriesScenes.edges) {
          slides.push(scene.node)
        }
      }
      return slides
    },
    initialSeriesIDs() {
      let ids = []
      if (this.initialSeries && this.initialSeries.edges) {
        for (const id of this.initialSeries.edges) {
          ids.push(this.decodeRelayID(id.node.id))
        }
      }
      return ids
    },
    getIndex() {
      let index = 0
      if(this.mainSlider){
      console.log("running computed")
      index = this.mainSlider.getInfo().index;
      } 
      return index
    }

  },
  watch: {},
});



// WEBPACK FOOTER //
// ./core/vue/js/commercial/commercial_collection.js